const BASE = import.meta.env.VITE_USE_EMULATORS === 'true'
  ? 'http://127.0.0.1:5001/beckersign/us-west2/signerApi'
  : 'https://us-west2-beckersign.cloudfunctions.net/signerApi';

export class ApiError extends Error {
  constructor(readonly status: number, message: string, readonly code?: string,
              readonly missingFieldIds?: string[]) {
    super(message);
  }
}

export async function call<T>(
  token: string, action: string, body: Record<string, unknown> = {}
): Promise<T> {
  const res = await fetch(`${BASE}/${action}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, ...body }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new ApiError(res.status, String(data.error ?? 'Something went wrong.'),
      data.code, data.missingFieldIds);
  }
  return data as T;
}

export interface SignerSession {
  envelopeName: string;
  messageToSigners: string;
  senderName: string;
  recipient: { name: string; email: string; role: string; status: string };
  requiresAccessCode: boolean;
  consented: boolean;
  disclosureVersion: string;
  documents: { id: string; name: string; pageCount: number; pageSizes: { width: number; height: number }[] }[];
  fields: import('@beckersign/shared').Field[];
  values: Record<string, string>;
  signature: boolean;
}
